import { Card, CardContent, Typography } from "@mui/material";
import { FC } from "react";

interface Props {
  value: number;
  title: string;
}

const CustomInfoBox: FC<Props> = ({ value, title }) => {
  return (
    <Card sx={{ height: "100%" }}>
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: 1,
          color: "#336B87",
        }}
      >
        <Typography variant="h4" fontWeight="bold">
          {value}
        </Typography>
        <Typography variant="body1" textAlign="center">
          {title}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default CustomInfoBox;
